<template>
    <componentType :item="item" />
</template>
<script setup>
import { computed } from 'vue'
import ProviderJob from './Job'
import ProviderJobRole from './Role'
import ProviderJobTitle from './Title'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const components = {
    ProviderJob,
    ProviderJobRole,
    ProviderJobTitle,
}

const componentType = computed(() => components[props.item.secondaryEntityType])
</script>
